import twopoolSwapABI from './json/2pool/swap';
import fusdtSwapABI from './json/fusdt/swap';
import fusdtDepositABI from './json/fusdt/deposit';
import renSwapAbi from './json/ren-ftm/swap';
import Plain2Basic from './json/factory-v2/Plain2Basic';
import Plain2BasicEMA from './json/factory-v2/Plain2BasicEMA';
import Plain2Balances from './json/factory-v2/Plain2Balances';
import Plain2ETH from './json/factory-v2/Plain2ETH';
import Plain2ETHEMA from './json/factory-v2/Plain2ETHEMA';
import Plain2Optimized from './json/factory-v2/Plain2Optimized';
import Plain3Basic from './json/factory-v2/Plain3Basic';
import Plain3Balances from './json/factory-v2/Plain3Balances';
import Plain3ETH from './json/factory-v2/Plain3ETH';
import Plain3Optimized from './json/factory-v2/Plain3Optimized';
import Plain4Basic from './json/factory-v2/Plain4Basic';
import Plain4Balances from './json/factory-v2/Plain4Balances';
import Plain4ETH from './json/factory-v2/Plain4ETH';
import Plain4Optimized from './json/factory-v2/Plain4Optimized';
import DepositZapFantom from './json/factory-v2/DepositZapFantom';
import MetaUSD from './json/factory-v2/MetaUSD';
import MetaUSDBalances from './json/factory-v2/MetaUSDBalances';
import MetaBTC from './json/factory-v2/MetaBTC';
import MetaBTCBalances from './json/factory-v2/MetaBTCBalances';
import MetaUSDGeist from './json/factory-v2/MetaUSDGeist';



import triCryptoSwapNoZap from './json/tricrypto/swap-no-zap';
import ibSwapABI from './json/ib/swap';
import aaveSwapABI from './json/aave/swap';
import paaveRewardsabi from './json/paave/rewards';
const multicall_address = '0xb828c456600857abd4ed6c32facc607bd0464f4f';

const poolsData = {
    '2pool': {
        swap_abi: twopoolSwapABI,
        N_COINS: 2,
        coin_precisions: [1e18, 1e6],
        wrapped_precisions: [1e18, 1e6],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        token_address: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        old_gauge: '0x0a53FaDa2d943057C47A301D25a4D9b3B8e01e8E', // Unused
        gauge_address: '0x8866414733F22295b7563f9C5299715D2D76CAf4',
        underlying_coins: [
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
        ],
        coins: [
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
        ],
    },
    fusdt: {
        swap_abi: fusdtSwapABI,
        N_COINS: 2,
        coin_precisions: [1e6, 1e18],
        wrapped_precisions: [1e6, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        deposit_abi: fusdtDepositABI,
        deposit_address: '0xa42bd395f183726d1a8774cfa795771f8acfd777',
        swap_address: '0x92d5ebf3593a92888c25c0abef126583d4b5312e',
        token_address: '0x92d5ebf3593a92888c25c0abef126583d4b5312e',
        old_gauge: '0x4f3E8F405CF5aFC05D68142F3783bDfE13811522', // Unused
        gauge_address: '0x06e3C4da96fd076b97b7ca3Ae23527314b6140dF',
        underlying_coins: [
            '0x049d68029688eabf473097a2fc38ef61633a3c7a',
            '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        ],
        coins: [
            '0x049d68029688eabf473097a2fc38ef61633a3c7a',
            '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        ],
        is_meta: true,
        base_pool: '2pool',
        meta_N: 4,
        meta_precisions: [1e6, 1e18, 1e18, 1e6],
        meta_coin_precisions: [1e6, 1e18, 1e6],
        meta_wrapped_precisions: [1e6, 1e18],
        meta_coins: [
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
        ],
        all_coins: [
            '0x049d68029688eabf473097a2fc38ef61633a3c7a',
            '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
        ],
    },
    'ren': {
        swap_abi: renSwapAbi,
        N_COINS: 2,
        coin_precisions: [1e8, 1e8],
        wrapped_precisions: [1e8, 1e8],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x3eF6A01A0f81D6046290f3e2A8c5b843e738E604',
        token_address: '0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858',
        old_gauge: '0x6600e98b71dabfD4A8Cac03b302B0189Adb86Afb',
        gauge_address: '0xBdFF0C27dd073C119ebcb1299a68A6A92aE607F0',
        underlying_coins: [
            '0x321162Cd933E2Be498Cd2267a90534A804051b11',
            '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
        coins: [
          '0x321162Cd933E2Be498Cd2267a90534A804051b11',
          '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
    },
    tricrypto: {
        swap_abi: triCryptoSwapNoZap,
        N_COINS: 3,
        pool_type: 'crypto',
        coin_precisions: [1e6, 1e8, 1e18],
        wrapped_precisions: [1e6, 1e8, 1e18],
        tethered: [false, false, false],
        use_lending: [false, false, false],
        is_plain: [true, true, true],
        swap_address: '0x3a1659Ddcf2339Be3aeA159cA010979FB49155FF',
        token_address: '0x58e57cA18B7A47112b877E31929798Cd3D703b0f',
        gauge_address: '0x00702BbDEaD24C40647f235F15971dB0867F6bdB',
        underlying_coins: [
          '0x049d68029688eAbF473097a2fC38ef61633A3C7A',
          '0x321162Cd933E2Be498Cd2267a90534A804051b11',
          '0x74b23882a30290451A17c44f4F05243b6b58C76d'
        ],
        coins: [
          '0x049d68029688eAbF473097a2fC38ef61633A3C7A',
          '0x321162Cd933E2Be498Cd2267a90534A804051b11',
          '0x74b23882a30290451A17c44f4F05243b6b58C76d'
      ]
    },
    ib: {
        swap_abi: ibSwapABI,
        N_COINS: 3,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e8, 1e8, 1e8],
        use_lending: [true, true, true],
        is_plain: [false, false, false],
        tethered: [false, false, false],
        is_new_underlying: true,
        swap_address: '0x4FC8D635c3cB1d0aa123859e2B2587d0FF2707b1',
        token_address: '0xDf38ec60c0eC001142a33eAa039e49E9b84E64ED',
        gauge_address: '0xDee85272EAe1aB4afBc6433F4d819BaBC9c7045A',
        underlying_coins: [
            '0x8D11eC38a3EB5E956B052f67Da8Bdc9bef8Abf3E',
            '0x04068DA6C83AFCFA0e13ba15A6696662335D5B75',
            '0x049d68029688eAbF473097a2fC38ef61633A3C7A',
        ],
        coins: [
            '0x04c762a5dF2Fa02FE868F25359E0C259fB811CfE',
            '0x328A7b4d538A2b3942653a9983fdA3C12c571141',
            '0x70faC71debfD67394D1278D98A29dea79DC6E57A',
        ],
    },
    geist: {
        N_COINS: 3,
        is_aave: true,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e18, 1e6, 1e6],
        use_lending: [false, false, false],
        tethered: [false, false, true],
        is_plain: [false, false, false],
        swap_address: '0x0fa949783947Bf6c1b171DB13AEACBB488845B3f',
        token_address: '0xD02a30d33153877BC20e5721ee53DeDEE0422B2F',
        gauge_address: '0xd4F94D0aaa640BBb72b5EEc2D85F6D114D81a88E',
        underlying_coins: [
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
            '0x049d68029688eabf473097a2fc38ef61633a3c7a',
        ],
        coins: [
            '0x07e6332dd090d287d3489245038daf987955dcfb',
            '0xe578c856933d8e1082740bf7661e379aa2a30b26',
            '0x940f41f0ec9ba1a34cf001cc03347ac092f5f6b5',
        ],
        swap_abi: aaveSwapABI,
        sCurveRewards_abi: paaveRewardsabi,
        // sCurveRewards_address: '0xd4f94d0aaa640bbb72b5eec2d85f6d114d81a88e',
        // reward_token: "0xd8321aa83fb0a4ecd6348d4577431310a6e0814d",
    },

};



const factoryPoolDataSkeleton = {
    swap_abi: fusdtSwapABI,
    N_COINS: 2, // to fill and replace w/ null in skeleton
    coin_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    tethered: [false, false], // to fill and replace w/ null in skeleton
    use_lending: [false, false], // to fill and replace w/ null in skeleton
    is_plain: [true, true], // to fill and replace w/ null in skeleton
    swap_address: '0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA', // to fill and replace w/ null in skeleton
    token_address: '0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA', // to fill and replace w/ null in skeleton
    gauge_address: '0x8866414733F22295b7563f9C5299715D2D76CAf4', // Fake pool address to prevent old multicalls from reverting
    underlying_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    deposit_abi: DepositZapFantom,
    deposit_address: '0xA79828DF1850E8a3A3064576f380D90aECDD3359',
    is_meta: true,
    base_pool: '3pool', // to fill and replace w/ null in skeleton
    meta_N: 5, // to fill and replace w/ null in skeleton
    meta_precisions: [1e18, 1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_coin_precisions: [1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    meta_coins: [ // to fill and replace w/ null in skeleton
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    all_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    is_factory: true,
    sCurveRewards_abi: undefined,
    sCurveRewards_address: undefined,
    reward_token: undefined,
};


export {
    multicall_address,
    poolsData,
    factoryPoolDataSkeleton,
    Plain2Basic,
    Plain2BasicEMA,
    Plain2Balances,
    Plain2ETH,
    Plain2ETHEMA,
    Plain2Optimized,
    Plain3Basic,
    Plain3Balances,
    Plain3ETH,
    Plain3Optimized,
    Plain4Basic,
    Plain4Balances,
    Plain4ETH,
    Plain4Optimized,
    MetaUSD,
    MetaUSDBalances,
    MetaBTC,
    MetaBTCBalances,
    MetaUSDGeist
};
